import React from "react";
import { Typography } from "@mui/material";
import styles from "./Boutique.module.css";
import { useTheme, useMediaQuery } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";

function BoutiqueEnligne({userData}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();


  const handleButtonClick = () => {
    const link = userData.lien_boutique?.trim(); // Trim whitespace
    console.log("Boutique Link:", userData.lien_boutique);
    // Check if the link exists
    if (link) {
      // Open the link in a new tab
      window.open(link, "_blank");
    } else {
      // Alert if the link is unavailable
      alert("Lien boutique n'est pas encore disponible !");
    }
  };

  
  return (
    <div className={styles["boutique-section"]}>
      <Typography
        variant="h4"
        style={{
          color: "#3F4C52",
          textAlign: "center",
          fontFamily: "DM Serif Display",
          fontSize: isSmallScreen ? "1.5rem" : "3.5rem",
          fontStyle: "normal",
          fontWeight: 400,
          "@media (max-width: 768px)": {
            fontSize: "6vw",
          },
        }}
      >
        {t("boutiqueTitle")}
      </Typography>
      <Typography
        variant="h4"
        sx={{
            color: "var(--taupe-fonc, #2E2E2E)",
            textAlign: "center",
            fontFamily: "Lato",
            fontSize: "19px",
            fontStyle: "normal",
            fontWeight: 400,
            width: "50%",
            whiteSpace: "pre-line",
            "@media (max-width: 600px)": {
              width: "100%",
            },
          }}
      >
        {t("boutiqueSubtitle1")}
      </Typography>
       <Typography
        variant="h4"
        sx={{
            color: "var(--taupe-fonc, #2E2E2E)",
            textAlign: "center",
            fontFamily: "Lato",
            lineHeight:"30px",
            fontSize: "19px",
            fontStyle: "normal",
            fontWeight: 400,
            width: "50%",
            whiteSpace: "pre-line",
            "@media (max-width: 600px)": {
              width: "100%",
            },
          }}
      >
       <Trans
          i18nKey="boutiqueSubtitle2"
          components={{ 1: <br /> }}
        />
      </Typography>
       <Typography
        variant="h4"
        sx={{
            color: "var(--taupe-fonc, #2E2E2E)",
            textAlign: "center",
            fontFamily: "Lato",
            fontSize: "19px",
            fontStyle: "normal",
            fontWeight: 400,
            width: "50%",
            whiteSpace: "pre-line",
            "@media (max-width: 600px)": {
              width: "100%",
            },
          }}
      >
       <Trans
          i18nKey="boutiqueSubtitle3"
          components={{ 1: <br /> }}
        />
      </Typography>
      <button className={styles["btn-more"]} onClick={handleButtonClick}>
               {t("boutiqueButton")}

      </button>
    </div>
  );
}

export default BoutiqueEnligne;
